(() => {
  const VARIANT_ROOT_SELECTOR =
    'variant-radios[data-tl-product-id]';

  const OPTION_SELECTOR =
    '[data-tl-option-position]';

  const VALUE_SELECTOR =
    'input[type="radio"][data-tl-value-position]';

  const GUIDE_SELECTOR =
    '[data-tl-guide]';

  const STRUTFIT_SELECTOR =
    'strutfit-size-button';

  const optionState =
    new WeakMap();


  function publish(
    eventName,
    payload
  ) {
    if (
      !window.Shopify?.analytics?.publish
    ) {
      return;
    }

    Shopify.analytics.publish(
      eventName,
      payload
    );
  }


  function getIdentityContext() {
    return (
      window.TLAnalyticsIdentity?.getContext?.() ||
      {
        tl_client_id: '',
        session_id: ''
      }
    );
  }


  function getLocale() {
    return (
      document.documentElement.lang
        ?.split('-')[0] ||
      'en'
    );
  }


  function getProductContext(
    root
  ) {
    if (!root) {
      return null;
    }

    return {
      ...getIdentityContext(),

      product_id:
        root.dataset.tlProductId || '',

      product_handle:
        root.dataset.tlProductHandle || '',

      product_title:
        root.dataset.tlProductTitle || '',

      product_type:
        root.dataset.tlProductType || '',

      initial_variant_id:
        root.dataset
          .tlInitialVariantId || '',

      locale:
        getLocale(),

      product_url:
        window.location.pathname
    };
  }


  function getCurrentVariantId(
    root
  ) {
    const input =
      root.querySelector(
        VALUE_SELECTOR
      );

    const formId =
      input?.getAttribute(
        'form'
      );

    if (formId) {
      const form =
        document.getElementById(
          formId
        );

      const variantInput =
        form?.querySelector(
          'input[name="id"]'
        );

      if (variantInput?.value) {
        return String(
          variantInput.value
        );
      }
    }

    return (
      root.dataset
        .tlInitialVariantId ||
      ''
    );
  }


  function initializeOptionState(
    root
  ) {
    if (
      !root ||
      optionState.has(root)
    ) {
      return;
    }

    const state = {};

    root
      .querySelectorAll(
        OPTION_SELECTOR
      )
      .forEach(
        (fieldset) => {
          const position =
            String(
              fieldset.dataset
                .tlOptionPosition ||
              ''
            );

          if (!position) {
            return;
          }

          const checked =
            fieldset.querySelector(
              `${VALUE_SELECTOR}:checked`
            );

          state[position] = {
            value:
              checked?.value || '',

            value_position:
              checked?.dataset
                .tlValuePosition ||
              ''
          };
        }
      );

    optionState.set(
      root,
      state
    );
  }


  function initializeAllVariantPickers() {
    document
      .querySelectorAll(
        VARIANT_ROOT_SELECTOR
      )
      .forEach(
        initializeOptionState
      );
  }


  function handleVariantChange(
    event
  ) {
    const input =
      event.target.closest?.(
        VALUE_SELECTOR
      );

    if (!input) return;

    const fieldset =
      input.closest(
        OPTION_SELECTOR
      );

    if (!fieldset) return;

    const root =
      input.closest(
        VARIANT_ROOT_SELECTOR
      );

    if (!root) return;

    const context =
      getProductContext(
        root
      );

    if (!context) return;

    const optionPosition =
      String(
        fieldset.dataset
          .tlOptionPosition ||
        ''
      );

    const optionName =
      fieldset.dataset
        .tlOptionName ||
      '';

    const valuePosition =
      String(
        input.dataset
          .tlValuePosition ||
        ''
      );

    const value =
      input.value || '';

    if (
      !optionState.has(root)
    ) {
      optionState.set(
        root,
        {}
      );
    }

    const state =
      optionState.get(
        root
      );

    const previous =
      state[
        optionPosition
      ] || {
        value: '',
        value_position: ''
      };

    if (
      previous.value === value &&
      previous.value_position ===
        valuePosition
    ) {
      return;
    }

    const payload = {
      ...context,

      variant_id:
        getCurrentVariantId(
          root
        ),

      option_position:
        Number(
          optionPosition
        ),

      option_name:
        optionName,

      value_position:
        Number(
          valuePosition
        ),

      value:
        value,

      previous_value_position:
        previous.value_position
          ? Number(
              previous.value_position
            )
          : '',

      previous_value:
        previous.value || ''
    };

    publish(
      'treadlabs:variant_option_selected',
      payload
    );

    state[
      optionPosition
    ] = {
      value:
        value,

      value_position:
        valuePosition
    };
  }


  function handleGuideClick(
    event
  ) {
    const opener =
      event.target.closest?.(
        GUIDE_SELECTOR
      );

    if (!opener) return;

    const guideType =
      opener.dataset.tlGuide;

    if (
      !guideType ||
      guideType === 'none'
    ) {
      return;
    }

    const root =
      document.querySelector(
        VARIANT_ROOT_SELECTOR
      );

    if (!root) return;

    const context =
      getProductContext(
        root
      );

    if (!context) return;

    let eventName = '';

    if (
      guideType === 'size'
    ) {
      eventName =
        'treadlabs:size_guide_open';

    } else if (
      guideType === 'arch'
    ) {
      eventName =
        'treadlabs:arch_guide_open';

    } else {
      return;
    }

    publish(
      eventName,
      {
        ...context,

        variant_id:
          getCurrentVariantId(
            root
          ),

        guide_type:
          guideType
      }
    );
  }


  function handleStrutfitClick(
    event
  ) {
    const path =
      typeof event.composedPath ===
        'function'
        ? event.composedPath()
        : [];

    const button =
      event.target.closest?.(
        STRUTFIT_SELECTOR
      ) ||
      path.find(
        (element) =>
          element?.matches?.(
            STRUTFIT_SELECTOR
          )
      );

    if (!button) return;

    const root =
      document.querySelector(
        VARIANT_ROOT_SELECTOR
      );

    if (!root) return;

    const context =
      getProductContext(
        root
      );

    if (!context) return;

    publish(
      'treadlabs:size_recommender_open',
      {
        ...context,

        variant_id:
          getCurrentVariantId(
            root
          )
      }
    );
  }


  document.addEventListener(
    'change',
    handleVariantChange,
    true
  );


  document.addEventListener(
    'click',
    (event) => {
      handleGuideClick(
        event
      );

      handleStrutfitClick(
        event
      );
    },
    true
  );


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllVariantPickers
    );

  } else {
    initializeAllVariantPickers();
  }
})();